






























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Mutations, Actions } from '@/ts/store/Constants';
import { Mutation } from 'vuex-module-decorators';
import { VuePaycard } from 'vue-paycard';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import ChooseAddingPaymentMethod from '@/components/User/Wallet/ChooseAddingPaymentMethod.vue';

@Component({
    components: {
        ChooseAddingPaymentMethod,
        Swiper,
        SwiperSlide,
        VuePaycard,
    },
    directives: {
        swiper: directive,
    },
    data() {
        return {
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination',
                },
            },
        };
    },
})

export default class CreditCards extends Vue {

    @Prop() public clickOnCard: boolean;

    public cardOverlay: number = -1;

    constructor() {
        super();
    }


    get mySwiper() {
        // @ts-ignore
        return this.$refs.mySwiper.$swiper;
    }


    get clickFunctionality() {
        return this.clickOnCard ? true : false;
    }


    get defaultPaymentMethodId() {
        return this.$store.getters['CreditCards/getDefaultPaymentMethodId'];
    }

    get cards() {
       return this.$store.getters['CreditCards/getCreditCards'];
    }

    public showCardActions(cardIndex: number) {
        this.cardOverlay = this.cardOverlay === cardIndex ? -1 : cardIndex;
    }

    public hideCardActions() {
        this.$store.commit(Mutations.SET_ACTIVE_CREDIT_CARD, this.cards[this.mySwiper.activeIndex]);
        this.cardOverlay = -1;
    }

    public deleteCard(cardId: number) {
        this.$store.dispatch(Actions.DELETE_USER_CREDIT_CARDS, cardId);
        this.hideCardActions();
    }

    public makePaymentDefault(cardId: number) {
        this.$store.dispatch(Actions.MAKE_PAYMENT_METHOD_DEFAULT, cardId);
    }

    public deleteDefaultPaymentMethod(cardId: number) {
        this.$store.dispatch(Actions.DELETE_DEFAULT_PAYMENT_METHOD, cardId);
    }

    public created() {
        if (this.cards) {
            this.$store.commit(Mutations.SET_ACTIVE_CREDIT_CARD, this.cards[0]);
        }
        this.$store.dispatch(Actions.GET_USER_DEFAULT_PAYMENT_METHOD);
    }
}
